import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { setNightTheme, setDayTheme } from '../../../actions/themeActions';
import MinuteHand from './minuteHand';
import HourHand from './hourHand';

const Frame = props => (
	<circle id="Clock-Frame" cx="53" cy="53" r="53" {...props}></circle>
);

const StyledFrame = styled(Frame)`
	transition: transform 350ms cubic-bezier(1, -0.01, 0, 1.74), fill ${props => props.theme.theming.nightDayTransitionDuration} ease;
	transform-origin: 4% 11%;
	fill: ${props => props.theme.hero.clockFill};
`;

const Clock = ({
	themeReducer,
	dispatch,
	...rest
}) => {
	const setNight = () => {
		if(themeReducer.isNightTheme) dispatch(setDayTheme());
		else dispatch(setNightTheme());
	};

	return (
		<g id="Clock" transform="translate(482.000000, 53.000000)" {...rest} onClick={setNight}>
			<StyledFrame />
			<circle id="Time" fillOpacity="0.1" fill="#000000" cx="53" cy="11" r="3"></circle>
			<circle id="Time" fillOpacity="0.1" fill="#000000" cx="11" cy="53" r="3"></circle>
			<circle id="Time" fillOpacity="0.1" fill="#000000" cx="95" cy="53" r="3"></circle>
			<circle id="Time" fillOpacity="0.1" fill="#000000" cx="53" cy="95" r="3"></circle>
			<MinuteHand />
			<HourHand />
			<circle id="Time-Center" fill="#C5CFD6" cx="53" cy="53" r="4"></circle>
		</g>
	);
};

const StyledClock = styled(Clock)`
	position: relative;
	cursor: pointer;

	#Time {
		transition: fill ${props => props.theme.theming.nightDayTransitionDuration} ease;
		fill: ${props => props.theme.hero.objectsFill00};
	}

	&:hover {
		${StyledFrame} {
			transform: scale(1.1);
			fill: ${props => props.theme.hero.clockFillDark};
		}
	}
`;

const mapStateToProps = ({ themeReducer }) => ({
	themeReducer
});

export default connect(mapStateToProps)(StyledClock);
